import { Modal } from 'antd';
import { BaseButton } from '../UI/BaseButton';

interface ConfirmStartSprintModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Confirmation step before starting a sprint (#206). Starting a sprint moves the
 * planned tasks into the active sprint and ends planning, so it shouldn't happen
 * on a single accidental click.
 */
export const ConfirmStartSprintModal = (props: ConfirmStartSprintModalProps) => {
  return (
    <Modal
      title="Start this sprint?"
      open={props.isOpen}
      onCancel={props.onCancel}
      onClose={props.onCancel}
      footer={null}
      width={640}
      centered
    >
      <div className="flex flex-col gap-6">
        <p className="text-neutral-900 text-sm font-normal leading-tight">
          This will end planning and move the selected tasks into the active sprint. You can't undo this.
        </p>

        <div className="flex justify-end gap-2">
          <BaseButton size="large" type="secondary" onClick={props.onCancel}>
            Cancel
          </BaseButton>

          <BaseButton size="large" type="accent" onClick={props.onConfirm}>
            Yes, Start Sprint
          </BaseButton>
        </div>
      </div>
    </Modal>
  );
};
